import { isEmpty, isNil } from "lodash";

export const validateRequiredFields = (values) => {
  const fields = Object.keys(values);
  const missing = fields.filter(
    (field) =>
      isNil(values[field]) ||
      (typeof values[field] === "object" && isEmpty(values[field]))
  );

  if (missing.length > 0) {
    console.error(`Missing required fields: ${missing.join(", ")}`, values);
    throw new Error(`Missing required fields: ${missing.join(", ")}`);
  }
};
